export type Resource = {id:string, value:any, status:ResourceStatus, extra: any};

export const STATUS_NONE = "None";
export const STATUS_FETCHING = "Fetching";
export const STATUS_SUCCESS = "Success";
export const STATUS_ERROR = "Error";

export type ResourceStatus = "None" | "Fetching" | "Success" | "Error";

export abstract class Lib<T> {
	public contents:Resource[] = [];
	protected map:{[id:string] : number} = {};

	public get = (id:string) => this.map.hasOwnProperty(id) ? this.contents[this.map[id]] : null;
	public has = (id:string) => this.map.hasOwnProperty(id);
	
	abstract remove: (id:string) => Promise<string>;
	abstract retrieve: (e:T, full:boolean) => Promise<T>
}